import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArLY: CultureInfo = {
  name: 'ar-LY',
  displayName: 'Arabic (Libya)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-LY',
  parent: CultureInfoAr
};
